const ANA_ALVAREZ_LINKEDIN = "https://www.linkedin.com/in/anaalvarezmonge/";
const KATRINA_ZUCHINA_LINKEDIN =
  "https://www.linkedin.com/in/katrina-zuchina-6053721b6/";

export const getCustomersTranslated = (t) => [
  {
    id: "ana-alvarez",
    name: t("landing.customers.testimonial_name_01"),
    role: t("landing.customers.testimonial_role_01"),
    quote: t("landing.customers.testimonial_quote_01"),
    linkedinUrl: ANA_ALVAREZ_LINKEDIN,
  },
  {
    id: "katrina-zuchina",
    name: t("landing.customers.testimonial_name_02"),
    role: t("landing.customers.testimonial_role_02"),
    quote: t("landing.customers.testimonial_quote_02"),
    linkedinUrl: KATRINA_ZUCHINA_LINKEDIN,
  },
];
